export const FETCH_PRODUCT_REVIEWS_REQUEST = 'reviews/FETCH_PRODUCT_REVIEWS_REQUEST';
export const FETCH_PRODUCT_REVIEWS_SUCCESS = 'reviews/FETCH_PRODUCT_REVIEWS_SUCCESS';
export const FETCH_PRODUCT_REVIEWS_FAILURE = 'reviews/FETCH_PRODUCT_REVIEWS_FAILURE';

export const FETCH_REVIEWS_OVERVIEW_REQUEST = 'reviews/FETCH_REVIEWS_OVERVIEW_REQUEST';
export const FETCH_REVIEWS_OVERVIEW_SUCCESS = 'reviews/FETCH_REVIEWS_OVERVIEW_SUCCESS';
export const FETCH_REVIEWS_OVERVIEW_FAILURE = 'reviews/FETCH_REVIEWS_OVERVIEW_FAILURE';
